import systemConfigs from '../_shared/constants/systemConfigs';

/**
 * TODO: Move to extend Singleton
 */
export default class SystemConfigService {
  private static instance: SystemConfigService;

  private configurations;

  constructor(configurations) {
    this.configurations = configurations;
  }

  public static get(configurations): SystemConfigService {
    if (!this.instance || !this.instance.configurations) {
      this.instance = new SystemConfigService(configurations);
    }

    return this.instance;
  }

  /**
   * Finds sys config value by key name
   */
  private getSystemConfigValue = key =>
    this.configurations?.find(configuration => configuration.key === key)
      ?.value;

  /**
   * Public Methods
   */

  /**
   * Active Timer
   */
  activeTimerFeatureEnabled = () =>
    this.getSystemConfigValue(systemConfigs.SHOW_ACTIVE_TIMER);

  /**
   * Bid Amount Threshold
   */
  getBidThresholds = () => {
    const threshold = Number.parseInt(
      this.getSystemConfigValue(systemConfigs.BID_THRESHOLD),
      10
    );
    const before = Number.parseInt(
      this.getSystemConfigValue(systemConfigs.BID_INCREMENT_BEFORE),
      10
    );
    const after = Number.parseInt(
      this.getSystemConfigValue(systemConfigs.BID_INCREMENT_AFTER),
      10
    );

    if (!threshold || !before || !after) {
      return null;
    }

    return {
      threshold,
      before,
      after
    };
  };

  getSSOSharedKey = () =>
    this.getSystemConfigValue(systemConfigs.SSO_SHARED_KEY);

  /**
   * Returns a list of distance values used for distance filter
   */
  getDistanceConfigurations = () => {
    try {
      return JSON.parse(
        this.getSystemConfigValue(systemConfigs.DISTANCE_CONFIGURATIONS)
      );
    } catch (e) {
      return [];
    }
  };
}
